/* eslint-disable no-unused-vars */
import React, { useState, useCallback, createContext } from "react";

export const GlobalConfirmContext = createContext({
  confirmProps: {
    type: "warning",
    title: "Titulo",
    message: "Mensagem",
    confirmText: "Confirmar",
    onClickConfirm: () => {},
    denyText: "Cancelar",
    onClickDeny: () => {},
    closeOnClickBackground: true,
  },
  addGlobalConfirm: ({
    type,
    title,
    message,
    confirmText,
    onClickConfirm,
    denyText,
    onClickDeny,
    closeOnClickBackground = true,
  }) => {},
  removeGlobalConfirm: () => {},
});

const GlobalConfirmProvider = ({ children }) => {
  const [confirmProps, setConfirmProps] = useState(null);

  const removeGlobalConfirm = () => setConfirmProps(null);

  const addGlobalConfirm = ({
    type,
    title,
    message,
    confirmText,
    onClickConfirm,
    denyText,
    onClickDeny,
    closeOnClickBackground = true,
  }) =>
    setConfirmProps({
      type,
      title,
      message,
      confirmText,
      onClickConfirm,
      denyText,
      onClickDeny,
      closeOnClickBackground,
    });

  const contextValue = {
    confirmProps,
    addGlobalConfirm: useCallback(
      (
        type,
        title,
        message,
        confirmText,
        onClickConfirm,
        denyText,
        onClickDeny,
        closeOnClickBackground,
      ) =>
        addGlobalConfirm(
          type,
          title,
          message,
          confirmText,
          onClickConfirm,
          denyText,
          onClickDeny,
          closeOnClickBackground,
        ),
      [],
    ),
    removeGlobalConfirm: useCallback(() => removeGlobalConfirm(), []),
  };

  return (
    <GlobalConfirmContext.Provider value={contextValue}>
      {children}
    </GlobalConfirmContext.Provider>
  );
};

export default GlobalConfirmProvider;
